<route>
{
  "name": "chapter",
  "meta": {
    "order": 1,
    "isVisible": false,
    "iconName": "mdi-home"
  }
}
</route>

<template>
  <div class="chapter-page">
    <page-title
      :title="$t('pages.questions.title') + ': ' + formData.name ? formData.name : ''">
      <v-btn
        outlined
        :to="{ name: 'questionAdd', params: { id: $route.params.id } }"
        class="ml-3"
        color="success">
        <v-icon
          class="ml-3">
          mdi-plus-thick
        </v-icon>
        {{$t('general.add')}}
      </v-btn>
      <v-btn
        outlined
        @click="$router.go(-1)"
        color="secondary">
        {{$t('general.back')}}
      </v-btn>
    </page-title>
    <v-row
      v-if="!pageDataIsReady"
      >
      <v-col
        cols="12">
        <v-skeleton-loader
          type="table"
          ></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-data-table
      v-if="pageDataIsReady"
      class="report-table"
      :headers="headers"
      :options="{
        itemsPerPage: 200
      }"
      :items="course"
      disable-sort>
      <template v-slot:item._id="{ item }">
        <pre> {{ item.question }} </pre>
      </template>
      <template v-slot:item.answers="{ item }">
        <pre> {{ item.answers.length }} </pre>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-row 
          v-if="item && item._id"
          class="flex-nowrap">
          <v-col cols="6" class="px-0">
            <v-btn
              icon
              color="primary"
              :to="{ name: 'questionEdit', params: { id: item._id.$oid } }">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import faker from 'faker'
faker.locale = 'fa'
export default {
  name: 'chapterPage',
  layout: APP_CONFIG.layout.mainPanelLayout,
  data () {
    return {
      pageDataIsReady: false,
      formData: {
        name: ''
      },
      course: []
    }
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('models.question'),
          value: 'question'
        },
        {
          text: this.$t('models.answers'),
          value: 'answers'
        },
        {
          text: this.$t('models.order'),
          value: 'order'
        },
        {
          text: '',
          width: 64,
          value: 'actions'
        },
      ]
    },
  },
  mounted () {
    this.preLoadData()
    this.$store.dispatch('course/getQuestions', {
      params: {
        chapter: this.$route.params.id
      }
    }).then((response) => {
      this.course = response.data
      this.pageDataIsReady = true
    })
  },
  methods: {
    preLoadData () {
      this.$store.dispatch('chapter/getById', {
        id: this.$route.params.id
      }).then((response) => {
        this.formData = response.data        
      })
    },
    toComplete () {
      console.log('chapter is completed')
    }
  }
}
</script>
